export default __webpack_public_path__ + "static/media/Footer.c8a1c681.png";